<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import "@/assets/font/iconfont.css";
export default {};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

img {
  user-select: none; /* 禁止选中 */
  pointer-events: none; /* 禁止点击 */
  -webkit-user-drag: none; /* 禁止拖拽（适用于WebKit浏览器） */
}
</style>
